import React from 'react';
import { useSelector } from 'react-redux';
import TechProjectInfo from '../../../components/techmng/info/TechProjectInfo';


const ProjectInfoContainer = ({ handleGoBack }) => {
  const { project } = useSelector(({ techModule }) => ({
    project: techModule.project.project,
  }));

  return <TechProjectInfo project={project} handleGoBack={handleGoBack} />;
};

export default ProjectInfoContainer;
